import { t as gsapWithCSS } from "@theme/gsap";
//#region frontend/islands/mega-menu-dropdown.js
var MegaMenuDropdown = class extends HTMLElement {
	connectedCallback() {
		this.panel = this.querySelector("[data-dropdown-panel]");
		this.header = this.closest("header");
		gsapWithCSS.set(this.panel, {
			clipPath: "inset(0 0 100% 0)",
			visibility: "hidden"
		});
		this.addEventListener("mouseenter", () => this.show());
		this.onHeaderLeave = () => this.hide();
		this.header?.addEventListener("mouseleave", this.onHeaderLeave);
		this.querySelector("a[aria-expanded]")?.addEventListener("focus", () => this.show());
		this.onKeydown = (e) => {
			if (e.key === "Escape") {
				this.hide();
				this.querySelector("a[aria-expanded]")?.focus();
			}
		};
		this.onFocusOut = (e) => {
			if (!this.contains(e.relatedTarget)) this.hide();
		};
		this.addEventListener("focusout", this.onFocusOut);
	}
	show() {
		this.header?.querySelectorAll("mega-menu-dropdown").forEach((el) => {
			if (el !== this) el.hide?.();
		});
		this.querySelector("a[aria-expanded]")?.setAttribute("aria-expanded", "true");
		document.removeEventListener("keydown", this.onKeydown);
		document.addEventListener("keydown", this.onKeydown);
		gsapWithCSS.to(this.panel, {
			clipPath: "inset(0 0 0% 0)",
			visibility: "visible",
			duration: .5,
			autoAlpha: 1,
			ease: "power2.out",
			overwrite: true
		});
	}
	hide() {
		this.querySelector("a[aria-expanded]")?.setAttribute("aria-expanded", "false");
		document.removeEventListener("keydown", this.onKeydown);
		gsapWithCSS.to(this.panel, {
			clipPath: "inset(0 0 100% 0)",
			duration: .5,
			ease: "power2.in",
			overwrite: true,
			autoAlpha: .25,
			onComplete: () => gsapWithCSS.set(this.panel, { visibility: "hidden" })
		});
	}
	disconnectedCallback() {
		this.header?.removeEventListener("mouseleave", this.onHeaderLeave);
		document.removeEventListener("keydown", this.onKeydown);
		this.removeEventListener("focusout", this.onFocusOut);
	}
};
window.customElements.define("mega-menu-dropdown", MegaMenuDropdown);
//#endregion
